import React from 'react';
import { outcomes } from '../data/outcomes';
export function ChangeSection() {
  return <section className="bg-white px-4 py-5" data-id="element-25" data-mp="zoafvbzyqfcf">
      <div className="mx-auto max-w-4xl" data-id="element-26" data-mp="zn95zauonywa">
        <h2 className="mb-2 text-center font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-27" data-mp="lwm4jaxjfuwi">
          Cosa cambierà
        </h2>
        <div className="grid gap-2 sm:grid-cols-2" data-id="element-28" data-mp="qtw1rcr65auw">
          {outcomes.map(outcome => <article key={outcome.title} className="rounded-xl border border-brand-line bg-brand-cream p-3 shadow-sm" data-id="element-29" data-mp="bxep8i78tq6r">
              <h3 className="font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-30" data-mp="2y1gxsuuv7nm">
                {outcome.title}
              </h3>
              <p className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-31" data-mp="7yp608zixef7">
                {outcome.description}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}